import { render, staticRenderFns } from "./RelatorioPerformanceRegiaoFiltroModalItem.vue?vue&type=template&id=5a6b991c"
import script from "./RelatorioPerformanceRegiaoFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./RelatorioPerformanceRegiaoFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports